export default "__VITE_ASSET__BvXPCeje__"